import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Sidebar from '../components/Sidebar';
import GameMenu from '../components/GameMenu';
import Timer from '../components/Timer';
import '../assets/css/fillthegap.css'
import bgShape1 from '../assets/images/bg/bgShape1';
import bgShape2 from '../assets/images/bg/bgShape2';
import decoOrange from '../assets/images/home/orange.svg'
import Popup from '../components/Popup';
import LeaveGamePopup from '../components/LeaveGamePopup';
import EndGameBtn from "../components/EndGameBtn";
import AnimatedBg from "../components/AnimatedBg";

export default function FillTheGap() {
    const [isFillTheGap, setIsFillTheGap] = useState(true);
    const [timerIsFinished, setTimerIsFinished] = useState(false);
    const [timeElapsed, setTimeElapsed] = useState(0);

    const sendTime = (time) => {
        setTimeElapsed(time);
    };

    const getTimerTimeRef = useRef(null);

    const [leaveGamePopup, setLeaveGamePopup] = useState(false);
    
    const sendLeaveGame = (value) => {
        setLeaveGamePopup(value);
    };

    const wordsAndSentences = [
        {
          word: "Capital",
          trad: "Capital",
          sentence: 'The startup successfully raised <span class="movable droppable">_____</span> through a series of venture funding rounds, enabling rapid growth and product development.'
        },
        {
          word: "Double",
          trad: "Double",
          sentence: "The marketing strategy aims to <span class='movable droppable'>_____</span> the company's market share within the next two years by leveraging data-driven insights and targeted advertising campaigns."
        },
        {
          word: "Bank",
          trad: "Banque",
          sentence: 'The multinational <span class="movable droppable">_____</span> launched a series of digital transformation initiatives to streamline operations and enhance customer service across all touchpoints.'
        }
    ].map(entry => ({
        ...entry,
        parts: parseSentenceToParts(entry.sentence)
    }));

    // const wordsAndSentences = [
    //     {
    //       word: "Capital",
    //       trad: "Capital",
    //       parts: [
    //             "The startup successfully raised ",
    //             "_____",
    //             " through a series of venture funding rounds, enabling rapid growth and product development."
    //         ]
    //     },
    //     {
    //       word: "Double",
    //       trad: "Double",
    //       parts: [
    //             "The marketing strategy aims to ",
    //             "_____",
    //             " the company's market share within the next two years by leveraging data-driven insights and targeted advertising campaigns."
    //         ]
    //     },
    //     {
    //       word: "Bank",
    //       trad: "Banque",
    //       parts: [
    //             "The multinational ",
    //             "_____",
    //             " launched a series of digital transformation initiatives to streamline operations and enhance customer service across all touchpoints."
    //         ]
    //     }
    // ];
    
    const [availableWords, setAvailableWords] = useState(wordsAndSentences.map(w => w.word));
    const [placedWords, setPlacedWords] = useState({});
    const [errorCount, setErrorCount] = useState(0);

    function parseSentenceToParts(sentence) {
        const regex = /(<span[^>]*>_____<\/span>)/g;
        const rawParts = sentence.split(regex);

        return rawParts.map(part => {
            if (part.includes("_____")) {
            return "_____";
            }
            // Supprime les balises HTML restantes
            return part.replace(/<\/?[^>]+(>|$)/g, "");
        });
    }

    const validateAnswers = () => {
        let errors = 0;

        const droppables = document.querySelectorAll(".droppable");

        droppables.forEach((el, index) => {
            const sentenceIndex = parseInt(el.closest('p').getAttribute('data-sentenceindex'), 10);
            const expectedWord = shuffledSentences[sentenceIndex]?.word;
            const userWord = el.textContent.trim();

            if (userWord === expectedWord) {
                el.classList.remove('wrong');
                el.classList.add('correct');
            } else {
                el.classList.remove('correct');
                el.classList.add('wrong');
                errors++;
            }
        });

        setErrorCount(errors);
    };

    const [correctionMode, setCorrectionMode] = useState(false);

    const handleCorrection = () => {
        console.log("Correction demandée !");
        setCorrectionMode(true); // Ou toute autre logique
        setTimerIsFinished(false);

        const wrongEls = document.querySelectorAll(".droppable.wrong");

        const wordsToRestore = [];

        wrongEls.forEach(el => {
            const wrongWord = el.textContent.trim();
            if (wrongWord && wrongWord !== "_____") {
                wordsToRestore.push(wrongWord);
            }

            // Réinitialiser l'affichage
            el.textContent = "_____";
            el.classList.remove("wrong", "correct", "filled");
        });

        // Remettre les mauvais mots dans les mots disponibles
        setAvailableWords(prev => [...prev, ...wordsToRestore]);
    };

    function shuffleArray(array) {
        return [...array].sort(() => Math.random() - 0.5);
    }

    const [shuffledSentences, setShuffledSentences] = useState([]);

    useEffect(() => {
        // const sentences = shuffleArray(wordsAndSentences.map(item => item.sentence));
        const sentences = shuffleArray(wordsAndSentences);
    
        setShuffledSentences(sentences);
    }, []);

    useEffect(() => {
        const droppables = document.querySelectorAll('.droppable');

        droppables.forEach(el => {
            el.addEventListener('dragover', (e) => {
            e.preventDefault(); // autorise le drop
            el.classList.add('drag-over');
            });

            el.addEventListener('dragleave', () => {
            el.classList.remove('drag-over');
            });

            el.addEventListener('drop', (e) => {
            e.preventDefault();
            el.classList.remove('drag-over');
            const droppedWord = e.dataTransfer.getData('text/plain');
            if (!droppedWord || el.textContent.trim() !== "_____") return;
            el.textContent = droppedWord;
            el.classList.add('filled');
            setAvailableWords(prev => prev.filter(w => w !== droppedWord));
            });
        });
    }, [shuffledSentences]);

    const lineAnimation = {
        rotate: [0, 5, -5, 0],
        scale: [1, 1.05, 0.95, 1],
        transition: {
        duration: 10, // lent
        ease: "easeInOut",
        repeat: Infinity,
        },
    };
    const circleAnimation = {
        y: [0, -10, 0, 10, 0],
        transition: {
        duration: 8,
        ease: "easeInOut",
        repeat: Infinity,
        },
    };
    const circleAnimationDelayed = {
        ...circleAnimation,
        transition: {
            ...circleAnimation.transition,
            delay: 2, // décalage en secondes
        },
    };

    const location = useLocation();
    const { theme, subTheme } = location.state || {};

    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container inGame" id="fillTheGap">
                <div class="title">
                    <h4>{theme} - {subTheme} </h4>
                    <div class="level-infos">
                        <Timer 
                            timer={timerIsFinished} 
                            onFinish={() => {
                                validateAnswers()
                                setTimerIsFinished(true)
                            }} 
                            onSendTime={sendTime} 
                            onGetTime={(getTimeFn) => getTimerTimeRef.current = getTimeFn}
                            hasLimit={false}
                        />
                    </div>
                </div>

                <div class="game-container launched">
                    <div id="words-container" class="word-container">
                        {availableWords.map((word, index) => {
                            const original = wordsAndSentences.find(w => w.word === word);
                            const trad = original ? original.trad : word;

                            return (
                            <span key={index} class="draggable draggable-HoverEffects movable word"
                                draggable 
                                onDragStart={(e) => e.dataTransfer.setData("text/plain", word)}
                                onMouseEnter={(e) => e.currentTarget.textContent = trad}
                                onMouseLeave={(e) => e.currentTarget.textContent = word}
                            >{word}</span>
                        )})}
                    </div>
                    <div id="phrases-container" class="flex-grow-1">
                        {/* {shuffledSentences.map(({ parts, word }, sentenceIndex) => (
                            <p key={sentenceIndex}>
                                {sentenceIndex + 1}.{" "}
                                {parts.map((part, i) => {
                                const key = `${sentenceIndex}-${i}`;
                                const currentWord = placedWords[key];

                                return part === "_____" ? (
                                    <span
                                    key={key}
                                    className={`droppable ${currentWord ? "filled" : ""}`}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                        const droppedWord = e.dataTransfer.getData("text/plain");
                                        if (!droppedWord || currentWord) return;

                                        setPlacedWords(prev => ({ ...prev, [key]: droppedWord }));
                                        setAvailableWords(prev => prev.filter(w => w !== droppedWord));
                                    }}
                                    onClick={() => {
                                        if (currentWord) {
                                        console.log("Clicked to remove:", currentWord);
                                        setPlacedWords(prev => {
                                            const updated = { ...prev };
                                            delete updated[key];
                                            return updated;
                                        });
                                        setAvailableWords(prev => [...prev, currentWord]);
                                        }
                                    }}
                                    >
                                    {currentWord || "_____"}
                                    </span>
                                ) : (
                                    <span key={key}>{part}</span>
                                );
                                })}
                            </p>
                        ))} */}
                        {shuffledSentences.map(({ parts, word }, sentenceIndex) => (
                            <p key={sentenceIndex} data-sentenceindex={sentenceIndex}>
                                {sentenceIndex + 1}.{" "}
                                {parts.map((part, i) => {
                                const key = `${sentenceIndex}-${i}`;
                                const currentWord = placedWords[key];

                                return part === "_____" ? (
                                    <span
                                    key={key}
                                    className={`droppable ${currentWord ? "filled" : ""}`}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                        const droppedWord = e.dataTransfer.getData("text/plain");
                                        if (!droppedWord || currentWord) return;

                                        setPlacedWords(prev => ({ ...prev, [key]: droppedWord }));
                                        setAvailableWords(prev => prev.filter(w => w !== droppedWord));
                                    }}
                                    onClick={() => {
                                        if (currentWord) {
                                        setPlacedWords(prev => {
                                            const updated = { ...prev };
                                            delete updated[key];
                                            return updated;
                                        });
                                        setAvailableWords(prev => [...prev, currentWord]);
                                        }
                                    }}
                                    >
                                    {currentWord || "_____"}
                                    </span>
                                ) : (
                                    <span key={key}>{part}</span>
                                );
                                })}
                            </p>
                        ))}
                    </div>
                </div>
                <EndGameBtn onClick={() => {
                    if (getTimerTimeRef.current) {
                        const currentTime = getTimerTimeRef.current();
                        sendTime(currentTime);
                    }
                    validateAnswers();
                    setTimerIsFinished(true);
                }} />
            </div>
            {/* <div id="fillTheGap-bg-decoL">
                {bgShape1.map((shape, i) => (
                    <motion.img
                        key={i}
                        src={shape}
                        alt={`shape-${i}`}
                        animate={{
                            rotate: [0, 8, -6, 0],
                            scale: [1, 1.07, 0.95, 1],
                            y: [0, -10, 10, 0],
                            opacity: [0.9, 1, 0.85, 1],
                        }}
                        transition={{
                            duration: 12,
                            ease: "easeInOut",
                            repeat: Infinity,
                            delay: i * 0.4,
                        }}
                        className="decoL"
                        style={{
                            transformOrigin: "center",
                            // zIndex: i % 2 === 0 ? 1 : 2,
                            filter: "blur(0.5px)",
                        }}
                    />
                ))}
                <motion.img src={decoOrange} animate={circleAnimation} className="decoL-orange" />
            </div>
            <div id="fillTheGap-bg-decoR">
                {bgShape2.map((shape, i) => (
                    <motion.img
                        key={i}
                        src={shape}
                        alt={`shape-${i}`}
                        animate={{
                            rotate: [0, 8, -6, 0],
                            scale: [1, 1.07, 0.95, 1],
                            y: [0, -10, 10, 0],
                            opacity: [0.9, 1, 0.85, 1],
                        }}
                        transition={{
                            duration: 12,
                            ease: "easeInOut",
                            repeat: Infinity,
                            delay: i * 0.4,
                        }}
                        className="decoR"
                        style={{
                            transformOrigin: "center",
                            // zIndex: i % 2 === 0 ? 1 : 2,
                            filter: "blur(0.5px)",
                        }}
                    />
                ))}
                <motion.img animate={circleAnimationDelayed} src={decoOrange} className="decoR-top-orange" />
                <motion.img animate={circleAnimation} src={decoOrange} className="decoR-bottom-orange" />
            </div> */}
            <AnimatedBg />
            <GameMenu onSendLeaveGame={sendLeaveGame}/>
            <Popup time={timeElapsed} timerIsFinished={timerIsFinished} errorCount={errorCount} isFillTheGap={isFillTheGap} onCorrection={handleCorrection} />
            <LeaveGamePopup popupOpen={leaveGamePopup} onSendLeaveGame={sendLeaveGame} />
        </div>
    )
}